import { Course } from "../../../types/course";
import { CourseModuleResponse } from "../../../types/courseMaterial";
import apiClient from "../config";

export const getCourses = async (): Promise<Course[]> => {
  const { data } = await apiClient.get("/public/getTopCoursesPublished");
  return data;
};

export const getCourse = async (courseId: number): Promise<Course> => {
  const { data } = await apiClient.get(`/public/getIndvCourse/${courseId}`);
  return data;
};

export const enrollCourse = async (
  courseId: number,
  memberNo?: string | null,
) => {
  if (isNaN(courseId)) {
    throw new Error("Invalid course ID");
  }

  // If memberNo is provided, use it as a referral
  const endpoint = memberNo
    ? `/student/chooseCourse/${courseId}/${memberNo}`
    : `/student/chooseCourse/${courseId}/0`;

  const { data } = await apiClient.post(endpoint);
  return data;
};

export const startCoursePayment = async (
  studentCourseId: number,
  flutterwaveTxnId: string,
  txRef: string,
): Promise<void> => {
  await apiClient.post(
    `/student/startCourse/${studentCourseId}/${flutterwaveTxnId}/${txRef}`,
  );
};

export const getCourseMaterial = async (
  studentCourseId: number,
): Promise<CourseModuleResponse> => {
  const { data } = await apiClient.get(
    `/student/viewCourseMaterial/${studentCourseId}`,
  );
  return data;
};

export async function getAllCourses() {
  const { data } = await apiClient.get(`/public/getAllCourse`);
  return data;
}

export async function startCourseScholarshipFromStudent(
  studentId: number,
  courseId: number,
) {
  const { data } = await apiClient.post(
    `/student/startCourseScholarshipFromStudent/${studentId}/${courseId}`,
  );
  return data;
}
